import clsx from 'clsx'
import React from 'react'
import { Skeleton, SkeletonProps } from '../Skeleton/Skeleton'

export const ButtonSkeleton = ({ className, ...props }: SkeletonProps) => {
  return (
    <Skeleton className={clsx('h-14 w-24 rounded', className)} {...props} />
  )
}
